import { Box, Typography } from "@mui/material";
import { ExamContainerInterface, ExerciseInterface } from "../../../../interfaces/examInterfaces";
import ExamHeader from "./PizLinardExamHeader";
import {
  AddExercise,
  AddExerciseContainerTopPage,
  ExamSheetContainer,
  ExercisesContainer,
  LineAddExercise,
  TopSpacer,
  TotalPoints,
  TotalPointsContainer,
} from "./PizLinardStyles";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import { motion } from "framer-motion";
import Exercise from "./PizLinardExercise";
import ExamFooter from "./PizLinardExamFooter";

export const PizLinardExamContainer = ({
  pageIndex,
  selectedObjective,
  pageExercises,
  exerciseRefs,
  pages,
  examName,
  amountExercises,
  totalPoints,
  imageUrls,
  solutionImageUrls,
  isCreatingAllPages,
  sortedExercises,
  zoomFactor,
  openAddExerciseDialog,
  showAddExercise,
  setShowAddExercise,
}: ExamContainerInterface) => {
  return (
    <ExamSheetContainer
      key={pageIndex}
      zoomfactor={zoomFactor}
      sx={{ visibility: isCreatingAllPages ? "hidden" : "block" }}
    >
      <TopSpacer zoomfactor={zoomFactor} />
      {pageIndex === 0 && selectedObjective && (
        <ExamHeader
          title={selectedObjective.topic}
          objectiveIndex={selectedObjective.objectiveIndex}
          objective={selectedObjective.objective}
          zoomFactor={zoomFactor}
        />
      )}

      <ExercisesContainer>
        {pageExercises.length === 0 ? (
          <AddExercise onClick={openAddExerciseDialog} sx={{ paddingTop: "5%" }}>
            <LineAddExercise />
            <NoteAddIcon></NoteAddIcon>
            <Typography>Aufgaben hinzufügen</Typography>
            <LineAddExercise />
          </AddExercise>
        ) : (
          <Box sx={{ position: "relative" }}>
            {pageExercises.map((exercise: ExerciseInterface, index: number) => {
              const imageUrl = imageUrls[exercise.id];
              const solutionImageUrl = solutionImageUrls[exercise.id];
              const showStickerNew = Math.floor(Date.now() / 1000) < exercise.newUntil;
              return (
                <div ref={(el) => (exerciseRefs.current[index] = el)} key={index}>
                  <motion.div
                    key={exercise.id}
                    layout
                    layoutId={`exercise-${exercise.id}`}
                    transition={{ type: "spring", stiffness: 500, damping: 50 }}
                  >
                    <Exercise
                      exercise={exercise}
                      amountExercises={amountExercises}
                      imageUrl={imageUrl}
                      solutionImageUrl={solutionImageUrl}
                      sortedExercises={sortedExercises}
                      showStickerNew={showStickerNew}
                    />
                  </motion.div>
                </div>
              );
            })}
            <AddExerciseContainerTopPage
              onMouseEnter={() => setShowAddExercise(true)}
              onMouseLeave={() => setShowAddExercise(false)}
              zoomfactor={zoomFactor}
            >
              {showAddExercise && (
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.2 }}
                  style={{ width: "100%", display: "flex", justifyContent: "center" }}
                >
                  <AddExercise onClick={openAddExerciseDialog}>
                    <LineAddExercise />
                    <NoteAddIcon></NoteAddIcon>
                    <Typography>Aufgaben hinzufügen</Typography>
                    <LineAddExercise />
                  </AddExercise>
                </motion.div>
              )}
            </AddExerciseContainerTopPage>
          </Box>
        )}
      </ExercisesContainer>

      {pageIndex === pages.length - 1 && (
        <TotalPointsContainer zoomfactor={zoomFactor}>
          <TotalPoints zoomfactor={zoomFactor}>/ {totalPoints}</TotalPoints>
        </TotalPointsContainer>
      )}
      {selectedObjective && (
        <ExamFooter
          examName={examName}
          zoomFactor={zoomFactor}
          title={selectedObjective.topic}
          objectiveIndex={selectedObjective.objectiveIndex}
        />
      )}
    </ExamSheetContainer>
  );
};
